export const API_URL = process.env.REACT_APP_API_URL;
export const FLAGS_URL = process.env.REACT_APP_FLAGS_URL;
